import { OnChanges } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { Output } from '@angular/core';
import { Input } from '@angular/core';
import { Component } from '@angular/core';
import { PublisherTagsAndPromotionalTypesSelectors } from 'app/modules/communication-centre/advertiser/store/publisher-tags-and-promotional-types/publisher-tags-and-promotional-types.selectors';
import { Localisation } from 'app/modules/main/components/data-selector/data-selector.models';
import { SelectableData } from 'app/modules/main/components/data-selector/data-selector.models';
import { PublisherTagColumnExtractor } from 'app/modules/main/components/publisher-tag-selector/publisher-tag-column-extractor.service';
import { PublisherTagSelectorMapper } from 'app/modules/main/components/publisher-tag-selector/publisher-tag-selector-mapper';
import { PublisherTag } from 'app/modules/main/models/publisher-tags-and-promotional-types';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-publisher-tag-selector',
  templateUrl: './publisher-tag-selector.component.html',
})
export class PublisherTagSelectorComponent implements OnChanges {

  @Input() readonly open: boolean = false;
  @Input() readonly required: boolean = false;
  @Input() readonly singular: boolean = false;

  @Input() readonly localisation?: Localisation = {
    title: $localize`:@@communication-centre.advertiser.publisher-tag-selector.title:Select Publisher Tags`,
    closeLabel: $localize`:@@communication-centre.advertiser.publisher-tag-selector.label.close:Close`,
    searchLabel: $localize`:@@communication-centre.advertiser.publisher-tag-selector.label.search:Search`,
    searchPlaceholder: $localize`:@@communication-centre.advertiser.publisher-tag-selector.label.search-placeholder:Tag`,
    allCategoriesLabel: $localize`:@@communication-centre.advertiser.publisher-tag-selector.label.all-categories:All`,
    selectAllLabel: $localize`:@@communication-centre.advertiser.publisher-tag-selector.label.select-all:All`,
    selectNoneLabel: $localize`:@@communication-centre.advertiser.publisher-tag-selector.label.select-none:None`,
    itemHeaderLabel: $localize`:@@communication-centre.advertiser.publisher-tag-selector.label.item-header:Item`,
    selectHeaderLabel: $localize`:@@communication-centre.advertiser.publisher-tag-selector.label.select-header:Select`,
    noDataText: $localize`:@@communication-centre.advertiser.publisher-tag-selector.no-data:You have no publisher tags`,
    noMatchesText: $localize`:@@communication-centre.advertiser.publisher-tag-selector.no-matches:Your filter criteria did not return any results.`,
    cancelLabel: $localize`:@@communication-centre.advertiser.publisher-tag-selector.button.cancel:Cancel`,
    submitLabel: $localize`:@@communication-centre.advertiser.publisher-tag-selector.button.submit:Select`,
  };

  @Input() readonly selectedPublisherTags: PublisherTag[];

  @Output() readonly submitted = new EventEmitter<PublisherTag[]>();
  @Output() readonly cancelled = new EventEmitter<void>();

  private initialized = false;

  readonly selectablePublisherTags = new BehaviorSubject<SelectableData<PublisherTag>[]>(null);

  constructor(
    readonly publisherTagColumnExtractor: PublisherTagColumnExtractor,
    private readonly publisherTagSelectorMapper: PublisherTagSelectorMapper,
    private readonly publisherTagsAndPromotionalTypesSelectors: PublisherTagsAndPromotionalTypesSelectors,
  ) {
  }

  ngOnChanges(): void {

    if (this.initialized || this.selectedPublisherTags === null) {
      return;
    }

    this.initialized = true;

    this.publisherTagsAndPromotionalTypesSelectors.getPublisherTagsAndPromotionalTypes()
      .pipe(
        take(1),
        map(publisherTagsAndPromotionalTypes => publisherTagsAndPromotionalTypes.publisherTags),
        map(publisherTags => this.publisherTagSelectorMapper.toSelectablePublisherTags(publisherTags, this.selectedPublisherTags)),
      )
      .subscribe(selectablePublisherTags => this.selectablePublisherTags.next(selectablePublisherTags));
  }

  public cancel(): void {
    this.cancelled.emit();
  }

  public submit(
    selectedPublisherTags: SelectableData<PublisherTag>[]
  ): void {

    const publisherTags = this.publisherTagSelectorMapper.toPublisherTags(selectedPublisherTags);

    this.submitted.emit(publisherTags);
  }

}
